import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/forgot-password/forgot-password-client.jsx");
